<template>

  <b-modal
    ref="modal"
    id="agLoginModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="loginButton_clicked">
    <template slot="modal-header">
      <h4 class="agModal-title">User Login</h4>
    </template>
    <b-input-group size="md" prepend="Username">
      <b-input type="text" v-model="username" @keyup.enter.native="loginButton_clicked"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Password">
      <b-input type="password" v-model="password" autocomplete="false" @keyup.enter.native="loginButton_clicked"></b-input>
    </b-input-group>
    <hr>
    <label v-if="errorMessage" class="agModal-message agModal-errorMessage">{{errorMessage}}</label>
    <template slot="modal-footer">
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button class="agModal-buttonRight" variant="primary" :disabled="isLoading" @click="loginButton_clicked">Login</b-button>
    </template>
  </b-modal>

</template>





<script>

  // components


  // modules
  import Server from "src/server";

  export default
  {
    name: "ag-login-modal",
    data()
    {
        return {
          isLoading: false,
          username: "",
          password: "",
          errorMessage: "",
          errorField: ""
      };
    },
    computed:
    {

    },
    methods:
    {
      async googleSignIn(){
        // firebase.auth()
      },
        // UI Events

        async loginButton_clicked()
        {
            if(!this.validate()) {
              return;
            }

            this.isLoading = true;
            var result = await this.$store.dispatch("userStore/login", {username:this.username, password:this.password});
            this.isLoading = false;
            if(result.data.success)
              this.hide();
            else
              this.errorMessage = result.data.error;
        },

        // other methods

        show() {
          setTimeout(() => {
            this.reset();
            this.$refs.modal.show();
          }, 250);        
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          this.errorMessage = "";
          this.errorField = "";
          this.username = "";
          this.password = "";
        },

        hasError(field)
        {
          if(field == this.errorField)
          {
              return false; // false = error
          }
          return null;
        },

        validate() {
            this.modalMessage = "";
            this.modalMessageClass = "";
            this.errorField = "";

            // validate fields
            if(!this.username)
            {
              this.errorMessage = "Username is required";
              this.errorField = "username";
              return false;
            }
            if(!this.password)
            {
              this.errorMessage = "Password is required";
              this.errorField = "password";
              return false;
            }

            return true;
        }
    }
  };

</script>






<style scoped lang="css">




</style>



// WEBPACK FOOTER //
// src/components/user/LoginModal.vue